import { FishingReport } from '@omniafishing/core';
import React, { useEffect } from 'react';
import { mapFishingReportIdsAndPositions } from '../../hooks/use_fishing_report_list_viewed';
import { WebAnalytics } from '../../lib/web_analytics';
import { FishingReportCard } from '../fishing_report_card/fishing_report_card';
import styles from './org_detail_fishing_reports_list.less';

interface OrgDetailFishingReportsListProps {
  fishingReports: FishingReport[];
  hasFilters: boolean;
}

export const OrgDetailFishingReportsList = (props: OrgDetailFishingReportsListProps) => {
  const { fishingReports, hasFilters } = props;

  useEffect(() => {
    if (fishingReports.length > 0) {
      WebAnalytics.fishingReportListViewed(
        'embedded',
        mapFishingReportIdsAndPositions(fishingReports)
      );
    }
  }, [fishingReports.map((fr) => fr.id).join(',')]);

  return (
    <>
      {fishingReports.length > 0 ? (
        <ul className={styles.list}>
          <div className={styles.frRows}>
            {fishingReports.map((fishingReport, i) => {
              return (
                <li key={fishingReport.id} className={styles.card}>
                  <FishingReportCard fishingReport={fishingReport} position={i} />
                </li>
              );
            })}
          </div>
        </ul>
      ) : (
        <>
          {hasFilters ? (
            <p>No fishing reports for those filters</p>
          ) : (
            <p>No fishing reports for this group yet</p>
          )}
        </>
      )}
    </>
  );
};
